import React, { useState, useEffect } from 'react';
import {
    Container,
    TextField,
    Button,
    Grid,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Paper,
    Typography,
    Pagination,
} from '@mui/material';
import { useNavigate } from 'react-router-dom'; // Import navigation hook

import { searchIncidents } from '../../api/api';

const IncidentsPage = () => {
    const [incidents, setIncidents] = useState([]);
    const [startDate, setStartDate] = useState('');
    const [endDate, setEndDate] = useState('');
    const [sourceId, setSourceId] = useState('');
    const [sourceType, setSourceType] = useState('');
    const [workflowId, setWorkflowId] = useState('');
    const [page, setPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1);

    const navigate = useNavigate(); // Initialize navigation

    const fetchIncidents = async () => {
        try {
            const response = await searchIncidents( {
                params: {
                    startDate,
                    endDate,
                    sourceId,
                    sourceType,
                    workflowId,
                    page,
                },
            });
            setIncidents(response.data.incidents);
            setTotalPages(response.data.totalPages);
        } catch (error) {
            console.error('Error fetching incidents:', error);
        }
    };

    const handleSearch = () => {
        setPage(1);
        fetchIncidents();
    };

    const handlePageChange = (event, value) => {
        setPage(value);
    };

    useEffect(() => {
        fetchIncidents();
    }, [page]);

    const handleRowClick = (incidentId) => {
        navigate(`/incident/${incidentId}`); // Navigate to detail page with incident ID
    };

    return (
        <Container>
            <Typography variant="h4" gutterBottom>
                Incident Dashboard
            </Typography>
            <Grid container spacing={2} marginBottom={2}>
                {/* Filters */}
                {/* ... (Same as before) */}
            </Grid>
            <TableContainer component={Paper}>
                <Table>
                    <TableHead>
                        <TableRow>
                            <TableCell>Source Type</TableCell>
                            <TableCell>Source ID</TableCell>
                            <TableCell>Created At</TableCell>
                            <TableCell>Workflow Name</TableCell>
                            <TableCell>Event Type</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {incidents.length > 0 ? (
                            incidents.map((incident) => (
                                <TableRow
                                    key={incident._id}
                                    onClick={() => handleRowClick(incident._id)} // Add click handler
                                    style={{ cursor: 'pointer' }}
                                >
                                    <TableCell>{incident.sourceType}</TableCell>
                                    <TableCell>{incident.sourceId['ATD Location ID']}</TableCell>
                                  
                                    <TableCell>{new Date(incident.createdAt).toLocaleString()}</TableCell>
                                    <TableCell>{incident.workflowId?.name || 'N/A'}</TableCell>
                                    <TableCell>{incident.eventId?.type || 'N/A'}</TableCell>
                                </TableRow>
                            ))
                        ) : (
                            <TableRow>
                                <TableCell colSpan={6} align="center">
                                    No incidents found.
                                </TableCell>
                            </TableRow>
                        )}
                    </TableBody>
                </Table>
            </TableContainer>
            <Pagination
                count={totalPages}
                page={page}
                onChange={handlePageChange}
                color="primary"
                style={{ marginTop: '20px', display: 'flex', justifyContent: 'center' }}
            />
        </Container>
    );
};

export default IncidentsPage;
